export default "__VITE_ASSET__Dp0gvIT9__"